const errorMessages = {
  required: "This field is required",
  email: {
    validEmailFormat: "Please enter a valid email address",
    validEmailDomain: "Please enter a work email, i.e."
  },
  phone: {
    numCharacters: "Phone number must contain ten digits",
    beginWithOne: "Phone number cannot begin with one",
    onlyDigits: "Please enter a valid phone number",
  },
};

export const phoneValidations = (value: string) => {
  const phoneMaxDigits = 10;
  const phoneRegex = /^\d{10}$/;
  const justNumbers = value.replace(/([\s-)(])/gi, "");
  if (justNumbers.length < phoneMaxDigits) {
    return errorMessages.phone.numCharacters;
  } else if (justNumbers[0] === "1") {
    return errorMessages.phone.beginWithOne;
  } else if (!justNumbers.match(phoneRegex)) {
    return errorMessages.phone.onlyDigits;
  }
  return true;
};

const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const emailValidations = (value: string, allowedDomains: string[]) => {
  if (!value.toLowerCase().match(emailRegex)) {
    return errorMessages.email.validEmailFormat;
  } else if (!allowedDomains.includes(value.split("@")[1])) {
    return `${errorMessages.email.validEmailDomain} ${allowedDomains && allowedDomains.join(", ")}`;
  }
  return true;
};

const Validations = {
  errorMessages,
  emailValidations,
  phoneValidations,
};

export default Validations;
